import { gql } from "@apollo/client";

export const GET_PACIENTE_ESTADO = gql`
    query pacienteEstado( $idPaciente: Int!){
        pacienteEstado( idPaciente: $idPaciente){
            idPacienteEstado
            idPaciente
            observaciones
            fechaEstado
            fechaAlta
            idUsuarioNavigation {
                idUsuario
                nombre
                apellido
            }
            idEstadoPacienteNavigation {
                idEstadoPaciente
                codigo
                descripcion
            }
            idMotivoAltaPacienteNavigation {
                idMotivoAltaPaciente
                descripcion
            }
        }
    }
`;

const adaptPacienteEstado = (pacienteEstado) => {
  return {
    idPacienteEstado: pacienteEstado?.idPacienteEstado,
    idPaciente: pacienteEstado?.idPaciente,
    observacion: pacienteEstado?.observaciones,
    fechaEstado: pacienteEstado?.fechaEstado,
    fechaAlta: pacienteEstado?.fechaAlta,
    usuario: pacienteEstado?.idUsuarioNavigation?.apellido + ', ' + pacienteEstado?.idUsuarioNavigation?.nombre,
    motivo: pacienteEstado?.idMotivoAltaPacienteNavigation?.descripcion,
    estado: '(' + pacienteEstado?.idEstadoPacienteNavigation?.codigo + ')' + ' ' + pacienteEstado?.idEstadoPacienteNavigation?.descripcion
  };
};

export const adaptPacienteEstadoArray = (pacientes) => {
  return structuredClone(pacientes)?.
  map((paciente) => adaptPacienteEstado(paciente));
};